<template>
<div class="hris-page">
  <div class="hris-page-inner">
    <div class="hris-page-header">
      <span class="hris-page-eyebrow">System Settings</span>
      <h1 class="hris-page-title">Employee Logs</h1>
      <p class="hris-page-subtitle">Audit trail of employee record actions and updates.</p>
    </div>

    <div class="hris-toolbar">
      <q-input type="date" dense outlined debounce="400" color="green" v-model="dateFrom" hint="Date From"></q-input>
      <q-input type="date" dense outlined debounce="400" color="green" v-model="dateTo" hint="Date To"></q-input>
      <q-btn unelevated class="hris-q-primary" label="Search" @click="searchDate"></q-btn>
      <div class="hris-toolbar-spacer"></div>
      <q-input dense outlined debounce="400" color="green" v-model="searchKey" placeholder="Search...">
        <template v-slot:append>
          <q-icon name="fa fa-search"></q-icon>
        </template>
      </q-input>
    </div>

    <div class="hris-panel">
      <q-table flat :data="searchVerifier" :columns="employeecolumn" :pagination="pagination" row-key="name" dense>
        <template v-slot:no-data="">
          <div class="hris-empty full-width">No employee logs found.</div>
        </template>
      </q-table>
    </div>
  </div>
</div>
</template>
<script>
import axios from 'axios';
export default {
    name: 'NewEmployeeLogs',
    data() {
        return {
            filter: '',
            employeecolumn: [
                { name: 'employee_id', field: 'employee_id', label: 'Employee ID' },
                { name: 'firstname', field: 'firstname', label: 'First Name' },
                { name: 'middlename', field: 'middlename', label: 'Middle Name' },
                { name: 'lastname', field: 'lastname', label: 'Last Name' },
                { name: 'action_taken', field: 'action_taken', label: 'Action Taken' },
                { name: 'effectivity', field: 'effectivity', label: 'Effectivity' },
                { name: 'date_created', field: 'date_created', label: 'Date Created' },
            ],
            searchKey: null,
            hidePagination: true,
            pagination: {
                sortBy: 'date_created',
                descending: true,
                page: 1,
                rowsPerPage: 15
            },
            rows: [],
            dateTo: null,
            dateFrom: null,
            searchDateToFrom: {
                dateTo: null,
                dateFrom: null,
            }
        }
    },
    created() {
        this.getEmployeeLogs()
    },
    computed: {
        searchVerifier() {
            if (this.searchKey !== null) {
                return this.rows.filter(row => {
                    return row.firstname.toLowerCase().match(this.searchKey) || row.firstname.toUpperCase().match(this.searchKey) ||
                    row.lastname.toLowerCase().match(this.searchKey) || row.lastname.toUpperCase().match(this.searchKey)
                });
            } else {
                return this.rows;
            }
        }
    },
    methods: {
        getEmployeeLogs () {
            axios.create({
                baseURL: this.apiUrl,
                headers: {
                'Authorization': `Bearer ${this.token}`
                }
            })
            .get(`/admin/get-employeelogs`)
            .then((res) => {
                this.rows = res.data.data;
            })
        },
        searchDate(){
            this.loading = true;
            let formData = new FormData();
            this.searchDateToFrom.dateFrom = this.dateFrom;
            this.searchDateToFrom.dateTo = this.dateTo;

            formData.append('form_data', JSON.stringify(this.searchDateToFrom));
            axios.create({
                baseURL: this.apiUrl,
                headers: {
                    'Authorization': `Bearer ${this.token}`
                }
                }).post('/admin/get-employeelogs-datecreated', formData).then((res) => {

                this.rows = res.data.data;
            });
        }
    }
}
</script>

<style>

</style>
